// Color
// ––––––––––––––––––––––––––––––––––––––––––––––––––

export default {
  initial: "#fff",
  primary: "#6acae0",
  secondary: "#606c76",
  tertiary: "#f4f5f6",
  quaternary: "#d1d1d1",
  quinary: "#e1e1e1",
  gradientDark: "#4c96d2",
  gradientLight: "#6acae0",
  gradientMid: "#55a7d6"
};
